var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmorphousBrain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 89,
    viewBox: "0 0 90 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.553664,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2194 88.36C59.0238 88.1441 58.7391 79.2984 66.9273 81.5574C75.1154 83.8164 83.8535 79.1635 87.3248 66.5568C90.796 53.9501 92.3725 34.9785 80.3973 19.0324C68.4222 3.08634 33.3732 -10.8885 14.654 13.3804C-4.06511 37.6492 -0.0582231 53.0263 3.36381 58.584C6.78584 64.1416 14.654 71.8423 28.9932 63.9803C43.3323 56.1183 34.7278 74.6998 38.1863 80.1952C41.6448 85.6906 41.4151 88.5759 50.2194 88.36Z",
    fill: "#008FD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4696 53.0262C48.4866 50.368 45.7571 33.8676 43.3491 23.7842C40.9411 13.7008 25.681 9.90717 18.8909 18.3419C12.1007 26.7766 2.4889 50.7051 11.9587 57.412C21.4285 64.1188 24.4526 55.6845 36.4696 53.0262Z",
    fill: "#00689B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53318,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4337 49.5762C48.6821 55.4272 35.6046 69.6499 48.3075 74.0111C61.0105 78.3723 80.4784 56.9951 80.4764 49.5872C80.4745 42.1793 83.0705 26.9674 68.4588 15.889C53.847 4.81067 34.3442 3.74754 29.9675 14.8396C28.0421 19.7194 26.6973 31.3149 29.9675 37.2012C34.1307 44.6949 43.6144 46.2992 45.4337 49.5762Z",
    fill: "#28CFFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.826683,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7802 45.8302C57.7557 50.6147 61.047 54.5498 57.5515 60.0712C54.056 65.5927 55.1684 77.6339 62.7802 74.6998C70.3919 71.7657 76.0748 77.6339 81.6545 65.0671C87.2342 52.5003 86.3825 40.1821 78.7508 39.8846C71.1191 39.5871 67.8047 41.0457 62.7802 45.8302Z",
    fill: "#FFCF12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.671805,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8838 50.1611C55.8059 55.5059 59.9298 59.8176 65.8966 57.8709C71.8633 55.9241 75.1376 45.8434 75.1375 41.6312C75.1375 37.419 75.5484 29.2817 71.1889 26.3969C66.8294 23.5121 60.7935 26.4587 58.2996 32.7665C55.8057 39.0743 51.9616 44.8164 53.8838 50.1611Z",
    fill: "#D6FF1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmorphousBrain);
export default __webpack_public_path__ + "static/media/amorphous-brain.a5f4090e.svg";
export { ForwardRef as ReactComponent };